import type { ChartImage, DropdownOption } from '../shared';
import type { ParsedValues } from './validation';

export const APP_NAME = 'iBlast';
export const APP_VERSION = '1.0.0';
export const APP_VERSION_POLICY = { currentVersion: APP_VERSION };
export const API_PATH = '/iBlast/';

export type APIPayload = Omit<ParsedValues, 'project' | 'title'>;

export type ChartKey = 'ufc_charts' | 'load';

export type ResultRow = {
  key: string;
  label_html: string;
  value: number | string | null;
  unit: string;
  unit_html: string;
  section?: string;
};

export type APIResponse = {
  results: ResultRow[];
  charts: Partial<Record<ChartKey, ChartImage>>;
  warnings?: Record<string, string>;
};

export type ResultSectionConfig = {
  title: string;
  keys: string[];
};

const CHARGE_TYPE_OPTIONS: DropdownOption[] = [
  { value: '0', label: 'Hemispherical' },
  { value: '1', label: 'Spherical' }
];

const CALCULATION_TYPE_OPTIONS: DropdownOption[] = [
  { value: '1', label: 'Charge Weight, Standoff, Angle -> Pressure, Impulse' },
  { value: '2', label: 'Pressure, Impulse, angle -> Charge Weight, Standoff' },
  { value: '3', label: 'Standoff, Pressure, angle -> Charge Weight, Impulse' },
  { value: '4', label: 'Charge Weight, Pressure, angle -> Standoff, Impulse' }
];

const TARGET_TYPE_OPTIONS: DropdownOption[] = [
  { value: '0', label: 'Front Wall' },
  { value: '1', label: 'Side Wall / Roof' },
  { value: '2', label: 'Back Wall' }
];

export const DROPDOWN_OPTIONS = {
  chargeType: CHARGE_TYPE_OPTIONS,
  calculationType: CALCULATION_TYPE_OPTIONS,
  targetType: TARGET_TYPE_OPTIONS
};
